import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Image } from './SuccessStoryDto';

interface SuccessStoryImageProps {
    image: Image;
    className?: string;
}

export default function SuccessStoryImage({ className, image }: SuccessStoryImageProps): JSX.Element {
    return (
        <TransitionGroup className={className}>
            <CSSTransition key={image.src} classNames="fade" timeout={600}>
                <img src={image.src} alt={image.alt} />
            </CSSTransition>
        </TransitionGroup>
    );
}
